<!-- 课表查询 -->
<template>
    <div class="el-timetableQuery">
        <el-row class="page_content">
            <h1 class="head_title">课表查询</h1>
            <el-form ref="form" :model="form" label-width="80px" v-if="!this.$strExistHostnameOnce(['localhost', 'lfjtysxx'])">
                <el-form-item label="学期">
                    <el-select v-model="form.region" :filterable="true" @change="selectScore" placeholder="请选择学期">
                        <el-option label="所有" value=""></el-option>
                        <template v-for="(item,index) in semesterList">
                          <el-option :key="index" :label="item" :value="item"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="semestersText"
                    header-align="center"
                    align="center"
                    label="学期"
                    v-if="!this.$strExistHostnameOnce(['localhost', 'lfjtysxx'])"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="courseName"
                    header-align="center"
                    align="center"
                    label="课程名称">
                </el-table-column>
                <el-table-column
                    prop="courseNatureConcat"
                    header-align="center"
                    align="center"
                    label="课程性质">
                </el-table-column>
                <el-table-column
                    prop="isOnline"
                    header-align="center"
                    v-if="!this.$strExistHostnameOnce(['localhost', 'czvtc'])"
                    align="center"
                    label="是否开通网学">
                    <template slot-scope="scope">
                      <el-link type="primary" v-if="scope.row.isOnline == 1" :underline="false">是</el-link>
                      <el-link type="primary" v-if="scope.row.isOnline == 2" :underline="false">否</el-link>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="teacherName"
                    header-align="center"
                    align="center"
                    label="教师名称">
                </el-table-column>
                <el-table-column
                    prop="teLessonsPlanOneTime"
                    header-align="center"
                    align="center"
                    label="第一次面授时间">
                </el-table-column>
                <el-table-column
                    prop="teLessonsPlanTwoTime"
                    header-align="center"
                    align="center"
                    label="第二次面授时间">
                </el-table-column>
                <el-table-column
                    prop="teLessonsPlanAddress"
                    header-align="center"
                    align="center"
                    label="面授地址">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="查看所有面授时间">
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click="selectData(scope.$index)">详情</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-dialog
            title="授课详情"
            :visible.sync="dialogVisible"
            width="800px"
            >
            <!-- <el-descriptions :colon="false" >
                <el-descriptions-item label="第一次面授时间：">{{dialogInfo.teLessonsPlanOneTime}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions :colon="false">
                <el-descriptions-item label="第二次面授时间：">{{dialogInfo.teLessonsPlanTwoTime}} </el-descriptions-item>
            </el-descriptions>
            <el-descriptions :colon="false">
                <el-descriptions-item label="面授地址：">{{dialogInfo.teLessonsPlanAddress}}</el-descriptions-item>
            </el-descriptions> -->
            <el-table
                :data="dialogInfo.teachingLessonsPlanList"
                height="250"
                style="width: 100%">
                <el-table-column prop="teLessonsPlanSort" label="面授顺序" width="130" align="center">
                    <template slot-scope="scope">
                        第 {{scope.$index + 1}} 次面授
                    </template>
                </el-table-column>
                <el-table-column prop="teLessonsPlanStartTime" label="面授时间" width="320"  align="center">
                    <template slot-scope="scope">
                        {{scope.row.teLessonsPlanStartTime}} 至 {{scope.row.teLessonsPlanEndTime}}
                    </template>
                </el-table-column>
                <el-table-column prop="teLessonsPlanAddress" label="面授地址"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
  name: "TimetableQuery",
  data() {
    return {
      semesterList:[], //学期List
      form:{
          region:""
      },
      tableData: [],
      semester:"",
      dialogInfo:{},
      dialogVisible: false,
      submitBut:false
    };
  },
  created() {
    this.getSemester();
  },
  methods: {
    getSemester(){ //获取学期
      this.$store.dispatch("user/getSemester").then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          if(ret.data.length > 0){
              if(!this.$strExistHostnameOnce(['localhost', 'lfjtysxx'])){
                this.form.region = ret.data[0];
                this.semester = ret.data[0];
              }
          }
          this.semesterList = ret.data;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
        this.getTeachingPlanCourse();
      })
    },
    getTeachingPlanCourse(){ //获取教学计划List
      this.$store.dispatch("user/getTeachingPlanCourse",{semester:this.semester}).then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.tableData = ret.data;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      })
    },
    selectScore(v){
      this.semester = v;
      this.getTeachingPlanCourse();
    },
    selectData(index){
      this.dialogInfo = this.tableData[index];
      this.dialogVisible = true;
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-timetableQuery{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
    .el-descriptions-item__container{
        font-size: 17px;
    }
    .el-descriptions-item__label {
        white-space: nowrap;
        width: 140px;
        text-align: right;
    }
    .el-descriptions-item__content{
        max-height: 200px;
        overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/teachingPlan/TimetableQuery.vue